import { Container, Card, Button } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import { useParams, useNavigate } from 'react-router-dom'

export default function ReceiptResult() {
    const { t } = useTranslation()
    const { status: stringStatus } = useParams<{ status: string }>();
    const navigate = useNavigate()
    const isSuccess = stringStatus ? parseInt(stringStatus) % 2 === 0 : false;

    return (
        <Container className="d-flex justify-content-center align-items-center vh-100">
            <Card className="text-center p-5 shadow-sm" style={{ maxWidth: '500px', width: '100%' }}>
                <Card.Body>
                    <div className="mb-4">
                        {isSuccess
                            ? <span style={{ fontSize: '4rem' }}><i className="fas fa-check"></i></span>
                            : <span style={{ fontSize: '4rem' }}><i className="fas fa-times"></i></span>
                        }
                    </div>
                    <Card.Title className="mb-3">
                        {isSuccess
                            ? t('receiptTranslate.paymentSuccess')
                            : t('receiptTranslate.paymentError')
                        }
                    </Card.Title>
                    <Card.Text className="text-muted mb-4">
                        {isSuccess
                            ? t('receiptTranslate.paymentSuccessMessage')
                            : t('receiptTranslate.paymentErrorMessage')
                        }
                    </Card.Text>
                    <Button
                        variant="primary"
                        className="w-100"
                        onClick={() => navigate('/identificacion')}
                    >
                        {t('global.return')}
                    </Button>
                </Card.Body>
            </Card>
        </Container>
    )
}